import { Injectable } from '@angular/core';
import Amplify, { Auth } from 'aws-amplify';
import { environment } from 'src/environments/environment';


export interface IUser {
    email: string;
    password?: string;
    showPassword?: boolean;
    code?: string | null;
    attributes?: {
        name: string;
        phone_number: string;
        picture?: string;
        given_name?: string;

    };
}

@Injectable({
    providedIn: 'root',
})
export class CognitoService {

    constructor() {
        Amplify.configure({
            Auth: environment.cognito,
        });
    }

    public async signUp(user: IUser): Promise<any> {
        return Auth.signUp({
            username: user.email,
            password: user.password || '',
            attributes: user.attributes,
        }).then(result => {
            return result;
        });
    }

    public confirmSignUp(user: IUser): Promise<any> {
        return Auth.confirmSignUp(user.email, user.code ?? '');
    }

    public async signIn(user: IUser): Promise<any> {
        const result = await Auth.signIn(user.email, user.password)
        return result;
    }

    public async signOut(): Promise<any> {
        return Auth.signOut();
    }

    public getUser(): Promise<any> {
        return Auth.currentUserInfo();
    }

    public async updateUser(user: IUser): Promise<any> {
        return Auth.currentUserPoolUser().then((cognitoUser: any) => {
            return Auth.updateUserAttributes(cognitoUser, user);
        });
    }

    public async updateAttrUser(attr: any) {
        const user = await Auth.currentAuthenticatedUser();
        return await Auth.updateUserAttributes(user, attr);
    }

    public async changePassword(oldPassword: string, newPassword: string) {
        const user = await Auth.currentAuthenticatedUser();
        await Auth.changePassword(user, oldPassword, newPassword);
    }

    public async forgotPassword(email: any) {
        return Auth.forgotPassword(email);
    }

    public async confirmPassword(email: string, verificationCode: any, newPassword: any) {
        return Auth.forgotPasswordSubmit(email, verificationCode, newPassword);
    }

    public async updatePasswordAndPicture(userObj: any) {
        const user = await Auth.currentAuthenticatedUser();

        await Auth.changePassword(user, 'fAZEJ@#12G1dBH', userObj.password);
        await Auth.updateUserAttributes(user, {
            picture: userObj.attributes.picture,
            'custom:activeStatus': 'true',
        });
    }

    public async updateUserUserAttrs(attrs: any) {
        const user = await Auth.currentAuthenticatedUser();
        return Auth.updateUserAttributes(user, attrs);
    }

    public async currentCredentials() {
        return Auth.currentSession();
    }

    public async logout() {
        return Auth.signOut();
    }
}
